"use client";
import {NeoModal} from "@/components/@modal/neo.modal";
import {NeoButton} from "@/components/forms";
import {useRoutePlan} from "@/context/routePlan/optimizer/routePlanVariant";
import {
  calcTime,
  formatTimeWithoutSecods,
  millisecondsToMinutes
} from "@/libs/helper";
import {routePlanService} from "@/service/routePlan.service";
import {Spinner} from "@nextui-org/react";
import clsx from "clsx";
import Image from "next/image";
import {useEffect, useState} from "react";
import {AiOutlineLoading} from "react-icons/ai";
import {FiSidebar} from "react-icons/fi";
import {GoArrowLeft} from "react-icons/go";

export const HitoryRoutePlan = function ({
  setIsHistoryTab
}: {
  setIsHistoryTab: (val: boolean) => void;
}) {
  //const [isHistoryTab, setIsHistoryTab] = useState(false);
  const [isHistDrawerOpen, setIsHistDrawerOpen] = useState(true);
  const [loading, setLoading] = useState(false);
  const [routePlanHistoryData, setRoutePlanHistoryData] = useState<
    RoutePlanInputHistory[]
  >([]);
  const [deletemodalOpen, setDeletemodalOpen] = useState(false);
  const [currentConfirmmodalOpen, setCurrentConfirmmodalOpen] = useState(false);
  //const [processingPopupmodal, setProcessingPopupmodal] = useState(false);
  const [setCurrentEditId, setSetCurrentEditId] = useState<string | null>();
  const [isProcessing, setisProcessing] = useState(false);
  const {planId, routePlanItem, setCurrentVariant} = useRoutePlan();
  const fetchData = async () => {
    setLoading(true);
    await routePlanService
      .getRoutePlanInputs(planId)
      .then((response: RoutePlanInputHistory[]) => {
        setRoutePlanHistoryData(response);
        const currentVariant = response.find(
          (variant: RoutePlanInputHistory) => {
            return variant.isCurrent === 1;
          }
        );
        if (currentVariant) {
          setCurrentVariant(currentVariant.variantId);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    if (routePlanItem) {
      const isProcess = routePlanItem?.status === 2;
      setisProcessing(isProcess);
      // setProcessingPopupmodal(isProcess);
    }
  }, [routePlanItem]);
  const setAsDefaultPlan = async () => {
    setLoading(true);
    if (setCurrentEditId) {
      await routePlanService
        .setAsDefaultRoutePlan(setCurrentEditId, planId)
        .then(response => {
          if (response?.data?.status === "success") {
            fetchData();
            setSetCurrentEditId(null);
            setCurrentConfirmmodalOpen(false);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };
  const confirmSetInputParmId = (variantId: any) => {
    setSetCurrentEditId(variantId);
    setCurrentConfirmmodalOpen(true);
  };

  const confirmDeleteHis = (variantId: any) => {
    setSetCurrentEditId(variantId);
    setDeletemodalOpen(true);
  };

  const deleteHistory = async () => {
    setLoading(true);
    if (setCurrentEditId) {
      await routePlanService
        .deletePlanHistory(setCurrentEditId, planId)
        .then(response => {
          if (response?.data?.status === "success") {
            fetchData();
            setSetCurrentEditId(null);
            setDeletemodalOpen(false);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };
  return (
    <div className="absolute left-2 top-2 z-10 w-96 rounded bg-white bg-opacity-90 p-2 shadow-md">
      <div className="mb-1 flex items-center justify-between border-b px-4">
        {/* Title */}
        <div className="flex items-center space-x-3">
          <button
            //title="View History"
            className={clsx(
              "inline-flex items-center rounded-md p-2 transition",
              isProcessing
                ? "cursor-not-allowed text-gray-400 opacity-60"
                : "text-gray-600 hover:text-gray-800"
            )}
            onClick={() => setIsHistoryTab(false)}
            title={isProcessing ? "Processing… please wait" : "View History"}
            //aria-disabled={isProcessing}
            //disabled={isProcessing}
          >
            <GoArrowLeft className="h-5 w-5" />
          </button>
          <h2 className="text-sm font-semibold text-gray-700">
            Planning Route History
          </h2>
        </div>

        {/* Action Icons */}
        <div className="flex items-center space-x-3">
          <button
            title="Open Drawer"
            className="text-gray-600 hover:text-gray-800"
            onClick={() => setIsHistDrawerOpen(!isHistDrawerOpen)}
          >
            <FiSidebar className="h-5 w-5" />
          </button>
        </div>
      </div>
      {loading ? (
        <div className="flex h-full w-full items-center justify-center">
          <Spinner color="primary" />
        </div>
      ) : routePlanHistoryData && routePlanHistoryData.length == 0 ? (
        <div className="flex h-full w-full flex-col items-center gap-1 p-3 text-center text-gray-500">
          <svg
            width="21"
            height="21"
            viewBox="0 0 21 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21 3.9375C21 5.99648 18.576 9.06855 17.5301 10.2949C17.3742 10.4754 17.1445 10.5451 16.9354 10.5H13.125C12.399 10.5 11.8125 11.0865 11.8125 11.8125C11.8125 12.5385 12.399 13.125 13.125 13.125H17.0625C19.2363 13.125 21 14.8887 21 17.0625C21 19.2363 19.2363 21 17.0625 21H5.72578C6.08262 20.5939 6.51738 20.073 6.95625 19.4906C7.21465 19.1461 7.48125 18.7688 7.73555 18.375H17.0625C17.7885 18.375 18.375 17.7885 18.375 17.0625C18.375 16.3365 17.7885 15.75 17.0625 15.75H13.125C10.9512 15.75 9.1875 13.9863 9.1875 11.8125C9.1875 9.63867 10.9512 7.875 13.125 7.875H14.7574C13.8961 6.58301 13.125 5.09824 13.125 3.9375C13.125 1.76367 14.8887 0 17.0625 0C19.2363 0 21 1.76367 21 3.9375ZM4.80293 20.0607C4.64707 20.2371 4.50762 20.393 4.38867 20.5242L4.31484 20.6062L4.30664 20.598C4.06055 20.7867 3.70781 20.7621 3.48633 20.5242C2.45273 19.4004 0 16.5088 0 14.4375C0 12.2637 1.76367 10.5 3.9375 10.5C6.11133 10.5 7.875 12.2637 7.875 14.4375C7.875 15.668 7.00957 17.1855 6.09082 18.4529C5.65195 19.0559 5.20078 19.6014 4.82754 20.032L4.80293 20.0607ZM5.25 14.4375C5.25 14.0894 5.11172 13.7556 4.86558 13.5094C4.61944 13.2633 4.2856 13.125 3.9375 13.125C3.5894 13.125 3.25556 13.2633 3.00942 13.5094C2.76328 13.7556 2.625 14.0894 2.625 14.4375C2.625 14.7856 2.76328 15.1194 3.00942 15.3656C3.25556 15.6117 3.5894 15.75 3.9375 15.75C4.2856 15.75 4.61944 15.6117 4.86558 15.3656C5.11172 15.1194 5.25 14.7856 5.25 14.4375ZM17.0625 5.25C17.4106 5.25 17.7444 5.11172 17.9906 4.86558C18.2367 4.61944 18.375 4.2856 18.375 3.9375C18.375 3.5894 18.2367 3.25556 17.9906 3.00942C17.7444 2.76328 17.4106 2.625 17.0625 2.625C16.7144 2.625 16.3806 2.76328 16.1344 3.00942C15.8883 3.25556 15.75 3.5894 15.75 3.9375C15.75 4.2856 15.8883 4.61944 16.1344 4.86558C16.3806 5.11172 16.7144 5.25 17.0625 5.25Z"
              fill="#818181"
            />
          </svg>
          <h1>No route plan history found</h1>
        </div>
      ) : (
        <>
          {isHistDrawerOpen && (
            <div className="max-h-[400px] space-y-2 overflow-y-auto pr-2">
              <div className="flex flex-col">
                <div className="space-y-2">
                  {routePlanHistoryData.map((plan, index) => (
                    <div
                      key={index}
                      className="rounded-xl border bg-white p-4 shadow-sm"
                    >
                      {/* Header */}
                      <div
                        className={`flex items-start justify-between border-b ${
                          plan.isCurrent
                            ? "border-b-yellow-500"
                            : "border-b-gray-300"
                        }`}
                      >
                        <div className="gap-2 pb-1">
                          <h2 className="text-sm font-semibold text-gray-800">
                            {plan.planName}
                          </h2>
                          <div className="flex items-center">
                            <p className="text-xs text-gray-500">
                              {calcTime(plan.createdDateTime)}
                            </p>
                          </div>
                        </div>
                        {plan.isCurrent ? (
                          <span className="rounded-full bg-blue-100 px-2 py-0.5 text-xs font-semibold text-blue-600">
                            Current
                          </span>
                        ) : (
                          <button
                            className="right-2 top-2 text-gray-500 hover:text-gray-700"
                            onClick={() => confirmDeleteHis(plan.variantId)}
                          >
                            ✕
                          </button>
                        )}
                      </div>
                      <span className="text-xs font-bold text-gray-500">
                        Input Parameters
                      </span>
                      {/* Stats */}
                      <div className="mt-1 grid grid-cols-2 gap-y-1 text-sm text-gray-700">
                        <div className="flex items-center gap-2">
                          <Image
                            src={`/icons/routePlan/users.svg`}
                            alt={""}
                            width={20}
                            height={20}
                            // className="mb-4"
                          />
                          <p className="text-sm font-bold">
                            {plan.inputUsers} Users
                          </p>
                        </div>
                        <div className="flex items-center gap-2">
                          <Image
                            src={`/icons/routePlan/yellowbus.svg`}
                            alt={""}
                            width={20}
                            height={20}
                            // className="mb-4"
                          />
                          <p className="text-sm font-bold">
                            {plan.inputVehicles} Vehicles
                          </p>
                        </div>
                        {/* trip type */}
                        <div className="flex items-center gap-2">
                          <Image
                            src={`/icons/routePlan/yellowpickup.svg`}
                            alt={""}
                            width={20}
                            height={20}
                            // className="mb-4"
                          />
                          <p className="text-sm font-bold">
                            {plan.tripType == 0 ? "Pickup" : "Drop"}
                          </p>
                        </div>
                        {/* Max time */}
                        <div className="flex items-center gap-2">
                          <Image
                            src={`/icons/routePlan/clock.svg`}
                            alt={""}
                            width={20}
                            height={20}
                            // className="mb-4"
                          />
                          <p className="text-sm font-bold">
                            {millisecondsToMinutes(plan.maxTime)} min
                            <span className="ml-1 text-xs font-normal">
                              Max time
                            </span>
                          </p>
                        </div>

                        <div className="flex items-center gap-2">
                          <Image
                            src={`/icons/routePlan/clock.svg`}
                            alt={""}
                            width={20}
                            height={20}
                            // className="mb-4"
                          />
                          <p className="text-sm font-bold">
                            {formatTimeWithoutSecods(plan.startTime)}
                            <span className="ml-1 text-xs font-normal">
                              Start time
                            </span>
                          </p>
                        </div>
                        <div className="flex items-center gap-2">
                          <Image
                            src={`/icons/routePlan/clock.svg`}
                            alt={""}
                            width={20}
                            height={20}
                            // className="mb-4"
                          />
                          <p className="text-sm font-bold">
                            {formatTimeWithoutSecods(plan.endTime)}
                            <span className="ml-1 text-xs font-normal">
                              End time
                            </span>
                          </p>
                        </div>
                        <div className="flex items-center gap-2">
                          <Image
                            src={`/icons/routePlan/duration.svg`}
                            alt={""}
                            width={20}
                            height={20}
                            // className="mb-4"
                          />
                          <p className="text-sm font-bold">
                            {millisecondsToMinutes(plan.waitTime)}
                            <span className="ml-1 text-xs font-normal">
                              Max wait
                            </span>
                          </p>
                        </div>
                        <div className="flex items-center gap-2">
                          <Image
                            src={`/icons/routePlan/yellowroute.svg`}
                            alt={""}
                            width={20}
                            height={20}
                            // className="mb-4"
                          />
                          <p className="text-sm font-bold">
                            {plan.maxDistance}
                            {" Km "}
                            <span className="ml-1 text-xs font-normal">
                              Max distance
                            </span>
                          </p>
                        </div>
                        {/* <div className="col-span-2 flex items-center gap-2">
                          <Image
                            src={`/icons/routePlan/users.svg`}
                            alt={""}
                            width={20}
                            height={20}
                            // className="mb-4"
                          />
                          <p className="text-sm font-bold">
                            {plan.maxCapacity}
                            <span className="ml-1 text-xs font-normal">
                              Capacity
                            </span>
                          </p>
                        </div> */}
                      </div>

                      {/* Show Details Button */}
                      {!plan.isCurrent && (
                        <div className="mt-1 border text-center">
                          <NeoButton
                            className="mx-5 border-none"
                            type="submit"
                            size="sm"
                            // disabled={isSubmitting}
                            onClick={() =>
                              confirmSetInputParmId(plan.variantId)
                            }
                            isLoading={loading}
                            spinner={
                              <AiOutlineLoading
                                size="xs"
                                className="animate-spin h-6 w-6"
                              />
                            }
                            color="white"
                            startContent={
                              <>
                                <svg
                                  width="14"
                                  height="15"
                                  viewBox="0 0 14 15"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g clip-path="url(#clip0_12650_7631)">
                                    <path
                                      d="M14 14.5H0V0.5H14V14.5Z"
                                      stroke="#E5E7EB"
                                    />
                                    <path
                                      d="M3.90742 4.40847C5.6082 2.70769 8.35625 2.69949 10.068 4.38113L8.94141 5.50496C8.75273 5.69363 8.69805 5.97527 8.79922 6.22136C8.90039 6.46746 9.14102 6.62605 9.40625 6.62605H12.6738H12.9062C13.2699 6.62605 13.5625 6.33347 13.5625 5.9698V2.4698C13.5625 2.20457 13.4039 1.96394 13.1578 1.86277C12.9117 1.7616 12.6301 1.81628 12.4414 2.00496L11.3039 3.14246C8.90859 0.777222 5.05039 0.785425 2.66875 3.1698C2.00156 3.83699 1.52031 4.62175 1.225 5.46121C1.06367 5.91785 1.3043 6.4155 1.7582 6.57683C2.21211 6.73816 2.7125 6.49753 2.87383 6.04363C3.08437 5.44753 3.42617 4.88699 3.90742 4.40847ZM0.4375 9.0323V9.24011V9.25925V12.5323C0.4375 12.7975 0.596094 13.0382 0.842187 13.1393C1.08828 13.2405 1.36992 13.1858 1.55859 12.9971L2.69609 11.8596C5.09141 14.2249 8.94961 14.2167 11.3313 11.8323C11.9984 11.1651 12.4824 10.3803 12.7777 9.54363C12.9391 9.08699 12.6984 8.58933 12.2445 8.428C11.7906 8.26668 11.2902 8.5073 11.1289 8.96121C10.9184 9.5573 10.5766 10.1178 10.0953 10.5964C8.39453 12.2971 5.64648 12.3053 3.93477 10.6237L5.05859 9.49714C5.24727 9.30847 5.30195 9.02683 5.20078 8.78074C5.09961 8.53464 4.85898 8.37605 4.59375 8.37605H1.32344H1.3043H1.09375C0.730078 8.37605 0.4375 8.66863 0.4375 9.0323Z"
                                      fill="#2563EB"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_12650_7631">
                                      <rect
                                        width="14"
                                        height="14"
                                        fill="white"
                                        transform="translate(0 0.5)"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>
                              </>
                            }
                          >
                            Set as Current
                          </NeoButton>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </>
      )}
      <NeoModal
        actionType={"editVehicleConfirmation"}
        onOpen={currentConfirmmodalOpen}
        onClose={() => setCurrentConfirmmodalOpen(false)}
        onModalSubmit={() => setAsDefaultPlan()}
        hasActions={true}
        data={{
          message:
            "Are you sure you want to set as current ? This action cannot be undone."
        }}
        //selectedRow={rowsData}
      ></NeoModal>

      <NeoModal
        actionType={"editVehicleConfirmation"}
        onOpen={deletemodalOpen}
        onClose={() => setDeletemodalOpen(false)}
        onModalSubmit={() => deleteHistory()}
        hasActions={true}
        data={{
          message:
            "Are you sure you want to delete ? This action cannot be undone."
        }}
        //selectedRow={rowsData}
      ></NeoModal>
      {/* routePlanProcessingPopup */}
      {/* <NeoModal
        actionType={"routePlanProcessingPopup"}
        onOpen={processingPopupmodal}
        onClose={() => setProcessingPopupmodal(false)}
        hasActions={false}
        //data={routePlanItem}
      ></NeoModal> */}
    </div>
  );
};
